import { createContext, useContext, useState, useRef, useEffect } from "react";

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [showFirst, setShowFirst] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [firstHeight, setFirstHeight] = useState(60);
  const firstNavbarRef = useRef(null);

  // measure navbar height once
  useEffect(() => {
    if (firstNavbarRef.current) {
      setFirstHeight(firstNavbarRef.current.offsetHeight);
    }
  }, []);

  // scroll listener for show/hide
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (currentScrollY <= 0) {
            // always show at very top
            setShowFirst(true);
          } else if (currentScrollY > lastScrollY + 2 && currentScrollY > 50) {
            // scrolling down → hide
            setShowFirst(false);
          } else if (currentScrollY < lastScrollY - 2) {
            // scrolling up → show
            setShowFirst(true);
          }

          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <NavbarContext.Provider value={{ showFirst, firstHeight, firstNavbarRef }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => useContext(NavbarContext);
